import { GmdGapOverviewData } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gmdGapOverviewData";
import { GmdGapRecords, GmdGapRecordsApiResponse } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gmdGapRecords";
import { mockDonutData1WithEcd, mockDonutData1WithoutEcd } from "@app/__tests__/__mocks__/gap-management-dashboard/getMockDonutData1";
import { mockDonutData2 } from "@app/__tests__/__mocks__/gap-management-dashboard/getMockDonutData2";
import { mockGapOverviewData } from "@app/__tests__/__mocks__/gap-management-dashboard/getMockGapOverviewData";
import { mockListData } from "@app/__tests__/__mocks__/gap-management-dashboard/getMockListData";
import { DonutProps } from "@app/shared/metrics/MetricsDonut";
import { ListLiteProps } from "@app/shared/metrics/MetricsListLite";
import ServiceBase from "@app/shared/serviceBase";
import { SortDirections } from "@app/shared/waffles";
import { GmdGapFlyoutResponseModel } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gapFlyoutResponseModel";

export class GapManagementDashboardService extends ServiceBase {  
  public async getGapOverviewData(_abort?: AbortSignal): Promise<GmdGapOverviewData> {
    return new Promise((resolve) => { window.setTimeout(() => { resolve(mockGapOverviewData); }, 1500) });
  }

  public async getFillabilityBreakdownData(userHasEcdRole?: boolean, _signal?: AbortSignal): Promise<DonutProps> {
    return new Promise((resolve) => { window.setTimeout(() => resolve(userHasEcdRole ? mockDonutData1WithEcd : mockDonutData1WithoutEcd), 1500) });
  }

  public async getResolutionStatusData(_signal?: AbortSignal): Promise<ListLiteProps> {
    return new Promise((resolve) => { window.setTimeout(() => resolve(mockListData), 1500) });
  }

  public async getPriorityDistributionData(_signal?: AbortSignal): Promise<DonutProps> {
    return new Promise((resolve) => { window.setTimeout(() => resolve(mockDonutData2), 1500) });
  }

  public async getGapRecordTableData(projectId: number, runConfigId: number, sortOptions: { column: keyof GmdGapRecords, direction: SortDirections }, pageIndex: number, pageSize: number, signal?: AbortSignal): Promise<GmdGapRecordsApiResponse> {
    return this.makePost(`/gapmanagement/projects/${projectId}/runconfigurations/${runConfigId}/gap-management-table`, { pageIndex, pageSize, sortOptions: [sortOptions] }, undefined, undefined, undefined, undefined, undefined, signal);
  }

  public async getGapProviderFlyoutData(projectId: number, runConfigId: number, regionSetSpecialtyGroupId: number, signal?: AbortSignal): Promise<GmdGapFlyoutResponseModel> {
    return this.makeGet(`/gapmanagement/projects/${projectId}/runconfigurations/${runConfigId}/regionsetspecialtygroupid/${regionSetSpecialtyGroupId}`, undefined, undefined, false, undefined, signal);
  }
}